/** Listas para el lugar de nacimiento: países (nombres en español), estados de México y EE. UU. */

/** Primero los países más comunes en nuestras iglesias. */
const FIRST = ['MX', 'US', 'GT', 'SV', 'HN', 'NI', 'CR', 'PA', 'CO', 'VE', 'EC', 'PE', 'BO', 'CL', 'AR', 'UY', 'PY', 'CU', 'DO', 'PR', 'ES', 'CA'];
const ALL = `AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GT GU GW GY HK HN HR HT HU ID IE IL IM IN IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG US UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW`.split(' ');

let names: Intl.DisplayNames | null = null;
export function countryName(code: string): string {
  try {
    names ??= new Intl.DisplayNames(['es'], { type: 'region' });
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}

const byName = (a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name, 'es');
export const COUNTRIES_FIRST = FIRST.map((code) => ({ code, name: countryName(code) }));
export const COUNTRIES_REST = ALL.filter((c) => !FIRST.includes(c)).map((code) => ({ code, name: countryName(code) })).sort(byName);

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Carolina del Norte', 'Carolina del Sur', 'Colorado', 'Connecticut', 'Dakota del Norte', 'Dakota del Sur',
  'Delaware', 'Distrito de Columbia', 'Florida', 'Georgia', 'Hawái', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Luisiana', 'Maine', 'Maryland',
  'Massachusetts', 'Míchigan', 'Minnesota', 'Misisipi', 'Misuri', 'Montana', 'Nebraska', 'Nevada', 'Nueva Jersey', 'Nueva York', 'Nuevo Hampshire', 'Nuevo México',
  'Ohio', 'Oklahoma', 'Oregón', 'Pensilvania', 'Rhode Island', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Virginia Occidental', 'Washington', 'Wisconsin', 'Wyoming',
];

/** Estados y municipios de México (se cargan solo cuando se necesitan). */
export const loadMexico = () => import('./mx-municipios.json').then((m) => m.default as Record<string, string[]>);

/** Nombres propios con mayúscula inicial, sin tocar partículas: "maría de la luz" → "María de la Luz". */
const PARTICLES = new Set(['de', 'del', 'la', 'las', 'los', 'y', 'e', 'van', 'von', 'da', 'di', 'do', 'dos']);
export function tidyName(value: string): string {
  const words = value.trim().replace(/\s+/g, ' ').split(' ');
  return words
    .map((w, i) => {
      const lower = w.toLocaleLowerCase('es');
      if (i > 0 && PARTICLES.has(lower)) return lower;
      return lower.replace(/(^|[-'])(\p{L})/gu, (_m, sep: string, ch: string) => sep + ch.toLocaleUpperCase('es'));
    })
    .join(' ');
}

export const NAME_PATTERN = /^[\p{L}\p{M}' .-]+$/u;
